import { useEffect, useState, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getCookie } from "../../helpers/cookie";
import { getUserAction } from "../../redux/actions/loginAction";
import { Box } from "@mui/material";
import { Triangle } from "react-loader-spinner";

// ==============================|| MINIMAL LAYOUT ||============================== //

export default function MinimalLayout() {
  const login = useSelector((state) => state.login);
  const userRoleRouters = useSelector((state) => state.userRoleRouters);
  const userRoute = userRoleRouters?.landingPage;

  const dispatch = useDispatch();
  const location = useLocation();

  const [token, setToken] = useState(() => getCookie("accessToken"));

  const checkAuthStatus = useCallback(() => {
    const currentToken = getCookie("accessToken");
    if (currentToken !== token) {
      setToken(currentToken);
    }
    if (currentToken && !userRoute?.[0]?.navPath) {
      dispatch(getUserAction());
    }
  }, [dispatch, token, userRoute]);

  useEffect(() => {
    if (token && !userRoute?.[0]?.navPath) {
      dispatch(getUserAction());
    }
  }, [dispatch, token, userRoute]);

  // Listen to focus, visibility change, and storage events so login in another tab navigates immediately
  useEffect(() => {
    checkAuthStatus();

    const handleFocus = () => checkAuthStatus();
    const handleVisibility = () => {
      if (document.visibilityState === "visible") {
        checkAuthStatus();
      }
    };
    const handleStorage = (e) => {
      if (e.key === "auth_sync" || e.key === "auth_logout" || !e.key) {
        checkAuthStatus();
      }
    };

    window.addEventListener("focus", handleFocus);
    document.addEventListener("visibilitychange", handleVisibility);
    window.addEventListener("storage", handleStorage);

    return () => {
      window.removeEventListener("focus", handleFocus);
      document.removeEventListener("visibilitychange", handleVisibility);
      window.removeEventListener("storage", handleStorage);
    };
  }, [checkAuthStatus]);

  const authPaths = [
    "/",
    "/login",
    "/register",
    "/registration",
    "/registration/existingregistration",
    "/changepassword",
  ];
  const isAuthRoute = authPaths.includes(location.pathname.toLowerCase());

  if (token && isAuthRoute) {
    const landingPath = userRoute?.[0]?.navPath || "/";
    const loading = login?.loading || userRoleRouters?.loading;

    if (loading && !userRoute?.[0]?.navPath) {
      return (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          <Triangle
            visible={true}
            height="150"
            width="200"
            color="#4076f5"
            ariaLabel="triangle-loading"
          />
        </Box>
      );
    }

    return <Navigate to={landingPath} replace />;
  }

  return <Outlet />;
}
